import { Component, Injector } from '@angular/core';
import { NavController, LoadingController, NavParams } from 'ionic-angular';
import { Util } from '../../app/util';
@Component({
  selector: 'page-conferma',
  templateUrl: 'conferma.html'
})
export class ConfermaPage extends Util {
  prodotti: any = [];
  params = { nome: '', cognome: '', email: '', note: '', indirizzo: '', citta: '', fascia_oraria: '', data_ritiro: '', piva: '', ragione_sociale: '', pec: '', sdi: '' };
  carrello_acquisto: any = [];
  carrello_reso: any = [];
  forarie: any = [];
  citta: any = [];
  today: string = "";
  dayNames: Array<string>;
  dayShortNames: Array<string>;
  monthNames: Array<string>;
  monthShortNames: Array<string>;
  textFocused : boolean = false;



  constructor(public navCtrl: NavController, injector: Injector, loadingCrtl: LoadingController, public navparams: NavParams) {
    super(injector, loadingCrtl)
    this.carrello_acquisto = this.navparams.get('carrello_acquisto');
    this.carrello_reso = this.navparams.get('carrello_reso');
    this.today = this.navparams.get('today');
    this.changeforarie(null);
    //console.log(this.prodotti);

    //this.maxDate = moment.utc().add(0, 'd').format('YYYY-MM-DD');
    // for(let i=0;i<this.prodotti.length;i++){
    //   if (this.prodotti[i].q > 0)
    //     this.carrello_acquisto.push(this.prodotti[i]);
    //   if(this.prodotti[i].r > 0)
    //     this.carrello_reso.push(this.prodotti[i]);
    // }
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.


    this.params['data_ritiro'] = new Date().toISOString();
    this.storage.get('userparams').then((user) => {
      if (user != '' && user != undefined && user != null) {
        this.params = user;
      }
    })




    this.citta = [
      { val: 'Campobasso', text: 'Campobasso' },
      { val: 'Ferrazzano', text: 'Ferrazzano' }
    ];

    this.dayNames = [
      "domenica",
      "lunedì",
      "martedì",
      "mercoledì",
      "giovedì",
      "venerdì",
      "sabato"
    ];

    this.dayShortNames = this.dayNames;
    this.monthNames = [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre'
    ];
    this.monthShortNames = this.monthNames;
  }

  changeforarie(data_ritiro) {

    if (data_ritiro == null) {
      data_ritiro = new Date().toISOString();
    }
    data_ritiro = data_ritiro.substring(0, 10);
    //console.log(data_ritiro);
    this.params['fascia_oraria'] = "";

    var allFasce = [
      { val: 9, text: 'dalle 09.00 alle 10.00' },
      { val: 10, text: 'dalle 10.00 alle 11.00' },
      { val: 11, text: 'dalle 11.00 alle 12.00' },
      { val: 12, text: 'dalle 12.00 alle 13.00' },
      //{ val: 15, text: 'dalle 15.00 alle 16.00' },
      { val: 16, text: 'dalle 16.00 alle 17.00' },
      { val: 17, text: 'dalle 17.00 alle 18.00' },
      { val: 18, text: 'dalle 18.00 alle 19.00' },
      { val: 19, text: 'dalle 19.00 alle 20.00' },
    ];



    if (data_ritiro == this.today) {
      this.forarie = [];
      var timeNow = new Date();
      let hour = timeNow.getHours();
      for (let fascia of allFasce) {
        if (fascia.val > hour) {
          this.forarie.push(fascia);
        }
      }
    } else {
      this.forarie = allFasce;
    }

    if (this.forarie.length > 0) {
      this.params['fascia_oraria'] = this.forarie[0].val;
    }


  }

  segmentChanged(e) {

  }
  ordina() {

    var errori_reso = [];
    for (let reso of this.carrello_reso) {
      if (reso.r == 0 || reso.r == null) {
        errori_reso.push("<b>" + reso.nome + "</b>");
      }
    }
    if (errori_reso.length > 0) {

      var prod_str = errori_reso.join("<br>");
      var alert_str = "";
      if (errori_reso.length == 1) {
        alert_str = 'Per il prodotto ' + prod_str + ' non hai selezionato la quantità di reso. Sei sicuro di voler proseguire?<br><br>Se è la prima volta che acquisti questo prodotto puoi ignorare questo avviso';
      } else {
        alert_str = 'Per i prodotti:<br> ' + prod_str + '<br> non hai selezionato la quantità di reso. Sei sicuro di voler proseguire?<br><br>Se è la prima volta che acquisti questi prodotti puoi ignorare questo avviso';
      }

      var that = this;
      let alert = this.alertCtrl.create({
        title: "Attenzione",
        subTitle: alert_str,
        buttons: [
          {
            text: 'Annulla',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Conferma Ordine',
            handler: data => {
              that.confermaOrdine();
            }
          }
        ]
      });
      alert.present();


    } else {

      this.confermaOrdine();

    }




    //this.navCtrl.push();
  }

  checkFocus() {
    //alert("xXXX");
    this.textFocused = true;
  }
  checkBlur() {
    this.textFocused = false;
  }

  confermaOrdine() {

    this.PostRequest(Util.getUrlServer() + 'action=getJSON&who=prenota_delivery', { user: this.params, acq: this.carrello_acquisto, res: this.carrello_reso }, true, true).then((res) => {
      this.storage.set('userparams', this.params);
      //this.showBasicAlert('Ordine registrato', 'La tua prenotazione è andata a buon fine. Verrai contattato a breve per la conferma dell\'ordine.');

      let alert = this.alertCtrl.create({
        title: "Grazie!",
        subTitle: 'Grazie per averci scelto.<br>Il tuo ordine è stato registrato. Verrai contattato a breve per la conferma della prenotazione.',
        buttons: [
          {
            text: 'Modifica Ordine',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Fatto',
            handler: data => {
              location.reload();
            }
          }
        ]
      });
      alert.present();


    }).catch((err) => {
      //this.showBasicAlert('Errore', 'Errore conferma ordine');
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/conferma/conferma.ts